@layer token {
  :root {
    /* BASE ----------------------------------------------------------------- */
    --n-toast-animation-duration-ms: 300;
    --n-toast-animation-duration: calc(
      var(--n-toast-animation-duration-ms) * 1ms
    );

    --n-toast-action-font-color-hover: var(--n-color-neutral-200);
    --n-toast-action-font-color-pressed: var(--n-color-neutral-300);
    --n-toast-action-gap: var(--n-space-gap-200);
    --n-toast-body-gap: var(--n-space-gap-200);
    --n-toast-content-gap: var(--n-space-gap-200);
    --n-toast-padding: var(--n-space-padding-300);

    --n-toast-bg-color: var(--n-color-surface-neutral-strong);
    --n-toast-border-radius: var(--n-border-radius-200);
    --n-toast-font-size: var(--n-font-size-350);
    --n-toast-font-weight: var(--n-font-weight-500);
    --n-toast-line-height: var(--n-font-line-height-500);
    --n-toast-font-color: var(--n-color-content-neutral-faint);
    --n-toast-shadow: var(--n-shadow-400);
  }
}

@layer component {
  /* BASE ------------------------------------------------------------------- */

  @keyframes enter {
    0% {
      display: none;
      opacity: 0;
      grid-template-rows: 0fr;
    }
    1% {
      display: grid;
    }
    10% {
      opacity: 0;
    }
    100% {
      opacity: 1;
      grid-template-rows: 1fr;
    }
  }

  @keyframes exit {
    0% {
      opacity: 1;
      grid-template-rows: 1fr;
    }
    10% {
      grid-template-rows: 1fr;
    }
    100% {
      opacity: 0;
      grid-template-rows: 0fr;
    }
  }

  .toast {
    opacity: 1;
    display: grid;
    grid-template-rows: 1fr;
    width: 100%;
    font-size: var(--n-toast-font-size);
    font-weight: var(--n-toast-font-weight);
    line-height: var(--n-toast-line-height);
    border-radius: var(--n-toast-border-radius);
    box-shadow: var(--n-toast-shadow);
    background-color: var(--n-toast-bg-color);
    color: var(--n-toast-font-color);

    @media (--mq-motion-ok) {
      animation-name: enter;
      animation-duration: var(--n-toast-animation-duration);
      animation-timing-function: ease-in-out;
      animation-fill-mode: forwards;
    }
  }

  .toast[data-variant='success'] {
    --n-toast-action-font-color-hover: var(--n-color-green-200);
    --n-toast-action-font-color-pressed: var(--n-color-green-300);
    --n-toast-bg-color: var(--n-color-surface-success-strong);
    --n-toast-font-color: var(--n-color-content-success-faint);
  }

  .toast[data-variant='error'] {
    --n-toast-action-font-color-hover: var(--n-color-red-200);
    --n-toast-action-font-color-pressed: var(--n-color-red-300);
    --n-toast-bg-color: var(--n-color-surface-error-strong);
    --n-toast-font-color: var(--n-color-content-error-faint);
  }

  .isExiting {
    @media (--mq-motion-ok) {
      animation-name: exit;
    }
  }

  .wrap {
    overflow: hidden;
    width: 100%;
  }

  .body {
    width: 100%;
    gap: var(--n-toast-body-gap);
    padding: var(--n-toast-padding);
  }

  .content {
    display: flex;
    align-items: center;
    gap: var(--n-toast-content-gap);
  }

  .actions {
    gap: var(--n-toast-action-gap);
    flex-shrink: 0;
  }

  .closeButton {
    color: var(--n-toast-font-color);
  }
}
